export const COVID_API_URL_ID1 = 'https://api.covid19api.com';
export const COVID_API_URL_ID2 = 'https://disease.sh';
export const COVID_SUMMARY_URL = `${COVID_API_URL_ID1}/summary`;
export const GEO_LOCATION_API_URL = 'https://corona.lmao.ninja/v2/countries'; // for markers features
export const POPULATION_API_URL = `${COVID_API_URL_ID2}/v3/covid-19/countries`;
export const COUNTRIES_TIME_SERIES_DATA_API_URL = `${COVID_API_URL_ID2}/v3/covid-19/countries`;
export const GLOBAL_TIME_SERIES_DATA_API_URL = `${COVID_API_URL_ID2}/v3/covid-19/historical/all?lastdays=366`;
export const MIN_NUM_OF_ITEMS_TO_SORT = 2;
export const RECOVERED = 'Recovered';
export const DEATHS = 'Deaths';
export const CONFIRMED = 'Confirmed';
export const MAX_STROKE_WIDTH = 51;
export const MIN_STROKE_WIDTH = 1;
export const DEFAULT_COUNTRY_COVID_OBJ = {
  NewConfirmed: 0,
  NewDeaths: 0,
  NewRecovered: 0,
  TotalConfirmed: 0,
  TotalDeaths: 0,
  TotalRecovered: 0,
};
export const CENTER_OF_THIS_EARTH = { lat: 52.52437, lng: 13.41053 };
export const DEFAULT_PERIOD = 'Total';
export const DEFAULT_QUALITY = 'AV';
export const ABSOLUTE = 'AV';
export const RELATIVE = 'RV';
export const VALUE = 100000;
export const GRAY = 'rgba(241, 241, 241, 1)';
export const DARK_GRAY = 'rgba(241, 241, 241, 0.5)';
export const RED = 'rgba(192, 8, 8, 0.7)';
export const GREEN = 'rgba(112, 168, 0, 0.7)';
